module.exports = __webpack_public_path__ + "static/media/personal_media.82e57676.xlsx";